import MasterSaleZoneList from './MasterSaleZoneList.vue';

export const saleZoneRoutes = [
  { path: 'saleZone', component: MasterSaleZoneList, name: 'saleZone' }
];
